import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Table,
} from "antd"
import { unwrapResult } from "@reduxjs/toolkit"
import layout from "antd/lib/layout"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { DateSelect } from "../../../compnents/form/DateSelect"
import { CloseOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons"
import { stringTrim } from "../../../utils/StringUtils"
import FileUpload from "../../../compnents/file/FileUpload"
import Upload, { RcFile } from "antd/lib/upload"
import { UploadFile } from "antd/lib/upload/interface"
import styles from "../filing.module.css"
import { DoctorFormModal } from "./DoctorFormModal"
import axios from "axios"
import { AXIOS_IP, downloadFile } from "../fileUploadService"

export const ZYTFAgainModal = (props: {
  visible: boolean
  token: string
  againName: string
  id?: string
  memo?: string
  filingTcmPatchRecordId?: string
  onOk: () => void
  onCancel: () => void
}) => {
  const { Option } = Select

  const { TextArea } = Input

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [fileList, setFileList] = useState<any>([])

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [baseUrl, setBaseUrl] = useState("")
    
  const [isModalVisible, setIsModalVisible] = useState(false) //预览

  //上年度效果评估报告
  const templateData = {
    fileConfigId: "5",
    fileName: "上年度效果评估报告模板",
    fileType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    filePath: "c5cb045f26657749dda8782d27ecaf3c277fceb0634e949ed62385cabdd116cb.xlsx",
  }

  // 处理文件上传前操作
  const beforeUploadFile = (file: File, urls: []) => {
    if (urls.length >= 1) {
      message.error("最多只能上传1个文件!")
      return Upload.LIST_IGNORE // 阻止上传
    }
    const isWord =
      file.type === "application/msword" ||
      file.type ===
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    const isPdf = file.type === "application/pdf"

    if (!isPdf) {
      message.error("PDF格式文件!")
      return false
    }
    const isLt2M = file.size / 1024 / 1024 < 10
    if (!isLt2M) {
      message.error("文件大小必须小于 10MB!")
    }
    return isLt2M
  }
  // 自定义上传实现
  const customRequest = async ({
    file,
    onSuccess,
    onError,
    onProgress,
  }: any) => {
    const formData = new FormData()
    formData.append("file", file)
    formData.append("name", file.name)
    try {
      // 使用axios发送请求
      const response = await axios.post(
        `${AXIOS_IP}/infra/file/uploadFile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )
            onProgress({ percent })
          },
        }
      )
      if (response.data) {
        const data = response.data
        setFileList([
          ...fileList,
          { fileConfigId: data?.configId, fileName: data?.name, fileType: data?.type, filePath: data?.path },
        ])
      }
      onSuccess(response.data)
      message.success(`上传成功`)
    } catch (error) {
      message.error(`上传失败`)
    }
  }

  const handleRemove = (type: string, index: number) => {
    setFileList(fileList?.filter((v: any, i: number) => i !== index))
  }

  const getBase64Url = (v: any, type = false) => {
    axios({
      url: `${AXIOS_IP}/infra/file/downloadFile/${v.fileConfigId}/${v.filePath}`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": props.token,
      },
      withCredentials: false,
      method: "GET",
    }).then((res: any) => {
      if(type) {
        const link = document.createElement('a');
        link.href = `data:${v.fileType};base64,${res.data}`
        link.download = '参考模板.pdf'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } else {
        setBaseUrl(`data:${v.fileType};base64,${res.data}`)
        setIsModalVisible(true)
      }
    })
  }

  useEffect(() => {
    form.setFieldsValue({
      previousYearAssessmentReportFileUrl: fileList,
    })
  }, [fileList])

  useEffect(() => { 
    if(!props.visible) {
      form.resetFields()
      setFileList([])
    } else {
      form.setFieldsValue({
        drugName: props.againName,
      })
    }
  }, [props.visible])

  return (
    <>
      <Modal
        title="中医贴敷重新备案"
        width={1000}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        onOk={form.submit}
        okText="提交"
        centered
        maskClosable={false}
        confirmLoading={confirmLoading}
      >
        <div>
          <Form
            form={form}
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            style={{ paddingRight: 10 }}
            onFinish={(vs) => {
              setConfirmLoading(true)
              const data = {
                ...vs,
                memo: props.memo,
                filingReviewTcmPatchRecordId: props.id,
                filingTcmPatchRecordId: props.filingTcmPatchRecordId,
              }
              axios({
                url: `${AXIOS_IP}/filingReviewTcmPatchRecord/restartFiling`,
                headers: {
                  "Content-Type": "application/json",
                  "His-Auth": props.token,
                },
                withCredentials: false,
                method: "POST",
                data,
              }).then(() => {
                notification.success({
                  message: "操作成功",
                })
                props.onOk()
              }).finally(() => {
                setConfirmLoading(false)
              })
            }}
          >
            <Row>
              <Col span={24}>
                <Form.Item
                  name="drugName"
                  label="名称"
                  rules={[{ required: true }]}
                >
                  <Input allowClear disabled />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  label="上年度效果评估报告"
                  name="previousYearAssessmentReportFileUrl"
                  rules={[{ required: true }]}
                >
                  <Row align="middle">
                    <Upload
                      customRequest={(options) => customRequest(options)}
                      beforeUpload={(file) => beforeUploadFile(file, fileList)}
                      showUploadList={false}
                      maxCount={1}
                      accept={".pdf"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    <span style={{ padding: "0 10px 0 15px" }}>
                      支持pdf等文件格式
                    </span>
                    <a
                      style={{ textDecoration: "underline", paddingRight: 10 }}
                      onClick={() => downloadFile(templateData, props.token, 'xlsx')}
                    >
                      参考模板
                    </a>
                    {fileList?.length > 0 &&
                      fileList?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              paddingRight: 10,
                            }}
                          >
                            <span
                              style={{ paddingRight: 10 }}
                            >
                              {v.fileName} <a style={{ paddingLeft: 10 }} onClick={() => getBase64Url(v)}>查看</a>
                            </span>
                            <CloseOutlined
                              style={{
                                position: "relative",
                                top: 2,
                                color: "rgb(161 161 161)",
                              }}
                              onClick={() => {
                                handleRemove("YS", index)
                              }}
                            />
                          </div>
                        )
                      })}
                  </Row>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={12}>
                <Form.Item
                  name="apparentEfficiency"
                  label="显效率"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 26 }}
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="recoveryRate"
                  label="治愈率"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 26 }}
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="adverseReactions"
                  label="不良反应"
                  rules={[{ required: true }]}
                >
                  <TextArea allowClear showCount maxLength={500} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>

      <Modal
        title={'预览'}
        visible={isModalVisible}
        footer={null}
        width={'80%'}
        onCancel={() => {
          setIsModalVisible(false)
        }}
      >
        <div style={{ height: '650px' }}>
          <iframe
            title='预览'
            style={{ width: '100%', height: '100%' }}
            src={baseUrl}
          />
        </div>
      </Modal>
    </>
  )
}
